module.exports = __webpack_public_path__ + "img/icon-kxlm.a704728c.png";